import { secureMainApi } from "../lib/apis";

/**
 * @description
 * Our request service.
 */

export interface Request {
	id: number;
	clientId: string;
	clientEmailAddress: string;
	institutionName: string | null;
	companyId: number;
	status: string;
	hasAcceptedCBDCTerms: boolean;
	acceptedCBDCTermsAt: number;
	tokenMigrationStatus: string;
	createdAt: number;
	updatedAt: number;
	locked: boolean;
	approvalStatus: APPROVAL_STATUS;
}

export enum APPROVAL_STATUS {
	APPROVED = "APPROVED",
	DECLINED = "DECLINED",
	PENDING = "PENDING",
	REVOKED = "REVOKED",
  PROCESSING = "PROCESSING"
}

interface RequestStat {
	key: string;
	value: number;
	first: string;
	second: number;
}
interface RequestResponse {
	content: Request[];
	pageable: {
		sort: {
			sorted: boolean;
			unsorted: boolean;
			empty: boolean;
		};
		pageNumber: number;
		pageSize: number;
		offset: number;
		paged: boolean;
		unpaged: boolean;
	};
	totalElements: number;
	totalPages: number;
	last: boolean;
	first: boolean;
	sort: {
		sorted: boolean;
		unsorted: boolean;
		empty: boolean;
	};
	size: number;
	number: number;
	numberOfElements: number;
	empty: boolean;
}

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class RequestService {
	/**
	 * @description
	 * Get list of access requests
	 */

	static async getAccessRequests(
		page: number,
		pageSize: number,
		search?: string,
	): Promise<RequestResponse> {
		const response = await secureMainApi.get("/admin/access/requests", {
			params: {
				page,
				pageSize,
				search,
			},
		});

		return response.data;
	}

	/**
	 * @description
	 * Get list of access request stats
	 */

	static async getRequestStats(): Promise<RequestStat[]> {
		const response = await secureMainApi.get("/admin/access/requests/stats");
		return response.data;
	}

	/**
	 * @description
	 * Approve request.
	 */

	static async approveRequest({
		requestId,
		enable,
	}: {
		requestId: number;
		enable: boolean;
	}): Promise<{ success: boolean }> {
		const response = await secureMainApi.put(
			`/admin/access/requests/${requestId}/approve`,
			undefined,
			{
				params: {
					enable,
				},
			},
		);
		return response.data;
	}

	/**
	 * @description
	 * Enable request.
	 */

	static async enableRequest({
		requestId,
		enable,
	}: {
		requestId: number;
		enable: boolean;
	}): Promise<{ success: boolean }> {
		const response = await secureMainApi.put(
			`/admin/access/requests/${requestId}/enable`,
			undefined,
			{
				params: {
					enable,
				},
			},
		);
		return response.data;
	}
}
